import React, { FC, useCallback, useEffect } from 'react'
import styles from 'styles/components/template.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import { Spacer } from 'components/Utility'
import { MainHeadline, SubDescription } from 'components/Typography'
import { BlueButton, NavButton } from 'components/Button'
import { TextInput } from 'components/Form'
import { FormLabel } from 'components/Label'
import { useString } from 'hooks/form'
import { State } from 'index'
import { getStoreRef } from 'reducks/auth/selectors'
import { fetchStoreDeliverySettings, saveStoreDeliverySetting } from 'reducks/storeDeliverySetting/operations'
import { getStoreDeliverySettings } from 'reducks/storeDeliverySetting/selectors'
import { StoreDeliverySettingType } from 'types/storeDeliverySetting'

const StoreDeliverySettingYamatoTemplate: FC = () => {
  const dispatch = useDispatch()
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const storeDeliverySettings = useSelector((state: State) => getStoreDeliverySettings(state))

  const { state: customerCode, handleState: handleCustomerCode, setState: setCustomerCode } = useString<string>('')
  const {
    state: feeManagementNumber,
    handleState: handleFeeManagementNumber,
    setState: setFeeManagementNumber,
  } = useString<string>('')

  const saveYamatoDeliverySetting = useCallback(() => {
    const storeDeliverySetting: StoreDeliverySettingType = {
      customer_code: customerCode,
      fee_management_number: feeManagementNumber,
    }
    dispatch(saveStoreDeliverySetting(storeRef, 'yamato', storeDeliverySetting))
    dispatch(push('/delivery/setting'))
  }, [customerCode, feeManagementNumber, storeRef])

  useEffect(() => {
    if (!storeDeliverySettings || storeDeliverySettings.length === 0) return
    const yamatoSetting = storeDeliverySettings.find(
      (storeDeliverySetting) => storeDeliverySetting.ref?.id === 'yamato'
    )
    if (!yamatoSetting) return
    setCustomerCode(yamatoSetting.customer_code)
    setFeeManagementNumber(yamatoSetting.fee_management_number)
  }, [storeDeliverySettings])

  useEffect(() => {
    if (!storeRef) return
    dispatch(fetchStoreDeliverySettings(storeRef))
  }, [storeRef])

  return (
    <div className={styles.standard}>
      <Spacer size={20} />
      <MainHeadline headline={'ヤマトビジネスメンバーズ情報'} />
      <Spacer size={28} />
      <SubDescription
        description={
          'ヤマトビジネスメンバーズにログインして、必要な情報を入力してください。アカウントをお持ちでないお客さまは、ヤマトビジネスメンバーズより登録が可能です。'
        }
      />
      <Spacer size={28} />
      <FormLabel id={'customer-code'} label={'請求先顧客コード'} required={false} />
      <Spacer size={4} />
      <SubDescription
        description={
          'ヤマト運輸が提供する送り状発行システムB2クラウドを利用する際に必要な、ヤマトビジネスメンバーズが発行している12桁の管理番号です'
        }
      />
      <Spacer size={8} />
      <TextInput
        disabled={false}
        maxLength={12}
        onChange={handleCustomerCode}
        placeholder={'012345678901'}
        required={false}
        size={'small'}
        type={'tel'}
        value={customerCode}
      />
      <Spacer size={20} />
      <FormLabel id={'fee-management-number'} label={'運賃管理番号'} required={false} />
      <Spacer size={4} />
      <SubDescription
        description={'ヤマト運輸が提供する送り状発行システムB2クラウドを利用する際に必要な請求先コードの一部です'}
      />
      <Spacer size={8} />
      <TextInput
        disabled={false}
        maxLength={2}
        onChange={handleFeeManagementNumber}
        placeholder={'01'}
        required={false}
        size={'small'}
        type={'tel'}
        value={feeManagementNumber}
      />
      <Spacer size={28} />
      <BlueButton label={'保存して終了する'} onClick={saveYamatoDeliverySetting} size={'medium'} type={'main'} />
      <Spacer size={48} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={72} />
    </div>
  )
}

export default StoreDeliverySettingYamatoTemplate
